(function($) {

    $(document).on('change', '.shipping-selector input[type="radio"]', function () {

        const method = $(this).val();

        document.dispatchEvent(
            new CustomEvent('gt:shipping-selector:change', {
                detail: {
                    method: method, context: $(this).closest('.shipping-selector').data('context')
                }
            })
        );
    });
}) (jQuery);